import { render, staticRenderFns } from "./RiskChart.vue?vue&type=template&id=4a371b37&scoped=true"
import script from "./RiskChart.vue?vue&type=script&lang=js"
export * from "./RiskChart.vue?vue&type=script&lang=js"
import style0 from "./RiskChart.vue?vue&type=style&index=0&id=4a371b37&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a371b37",
  null
  
)

export default component.exports